import type { ApolloCache, MutationUpdaterFunction } from '@apollo/client';

import { updateCache } from 'src/modules/apollo/apolloCache';
import type {
  DeleteProfileAvatarMutation,
  DeleteProfileAvatarMutationVariables,
} from 'src/types/graphql';

export const updateCacheDeleteProfileAvatar: MutationUpdaterFunction<
  DeleteProfileAvatarMutation,
  DeleteProfileAvatarMutationVariables,
  unknown,
  ApolloCache<any>
> = (cache, { data }) => {
  const { deleteProfileAvatar } = data || {};

  // Only update cache if mutation was successful
  if (deleteProfileAvatar?.__typename === 'DeleteProfileAvatarSuccess') {
    // Update cache to set profileAvatar to null
    updateCache({ cache, data: null, fieldName: 'profileAvatar' });
  }
};
